<template>
  <el-tree
    class="overflow-auto h-full cableModelTree"
    :props="treeProps"
    ref="modelTreeCableRef"
    :load="loadNode"
    highlight-current
    :lazy="true"
    show-checkbox
    :current-node-key="currentKey"
    :default-checked-keys="modelTreeProp.defaultCheckedKey"
    :default-expanded-keys="defaultExpandedKeys"
    @node-click="clickModelTree"
    node-key="item"
  ></el-tree>
</template>

<script>
import cloudRender from '../assets/js/model/index'
import { isJSONObj } from '../assets/js/scene/scene'

export default {
  props: ['player', 'sceneId'],
  data() {
    return {
      treeProps: {
        label: 'name',
        children: 'children',
        isLeaf: 'leaf',
      },
      modelTreeProp: {
        currentNodeItem: 0, // 当前激活的node
        currentNodeName: '', // 点选时当前激活的节点名称
        treeData: [], // 模型树数据
        defaultCheckedKey: [], // 模型树选中的节点
        filterItem: [], // 模型树不需要显示的节点及他的父节点列表
        modelHideList: [], // 模型隐藏队列
        modelTreeLoadEnd: false, // 模型树数据加载完毕
        spaceSwapStatus: false, // 交换空间状态
      },
      defaultExpandedKeys: [],
      modelTreeObj: {
        ITEM_PR: 0, // PR 文件节点类型
        ITEM_NODE: 1, // CELLNode文件节点类型
        ITEM_GISOBJ: 2, // gis 数据对象
        ITEM_NULL: 3, // 仅仅对根节点使用
      },
      currentNode: {},
      currentKey: '',
    }
  },
  methods: {
    filterNode(value, data) {
      if (!value) return true
      if (value === 'NotCode') return false
      return data.name.indexOf(value) !== -1
    },
    // 模型树加载
    async loadNode(node, resolve) {
      if (node.level === 0) {
        if (this.modelTreeProp.treeData.length === 0) {
          await this.getModelTreeDatas()
        }

        return resolve(this.modelTreeProp.treeData)
      }
      const res = await cloudRender.Node.findItemChild(this.player, node.data.item)

      const filterRes = _.filter(res.data, (el) => {
        return el?.name && el?.visible
      })
      _.forEach(filterRes, async (el) => {
        if (
          isJSONObj(node.data.code) &&
          (JSON.parse(node.data.code).type === 'Root' ||
            JSON.parse(node.data.code).type === 'userData') &&
          el.itemType === 0 &&
          el.nodePtr
        ) {
          const nodeInfo = await this.player.Native.NodeProxy.getNodeInfo(el.nodePtr)
          if (nodeInfo.name) {
            el.name = nodeInfo.name
          }
          el.code = nodeInfo.code
        }
      })

      resolve(filterRes)
    },
    locationCode(item) {
      this.player.Native.Camera.moveToItem(item, 2)
      this.player.Native.ModelTree.setSelectItem(item)
    },
    locationNode(id) {
      window.modelTreeCableRef = this.$refs.modelTreeCableRef
      this.$nextTick(() => {
        setTimeout(() => {
          this.$refs.modelTreeCableRef.setCurrentKey(id)
          setTimeout(() => {
            const node = document.getElementsByClassName('cableModelTree')[0]
            const currentNode = document.getElementsByClassName('is-current')[0]
            node.scrollTo({
              top: currentNode.offsetTop,
            })
          }, 600)
        }, 500)
      })
    },
    async expendNode(nodeInfo) {
      // item: 1为pr模型跟， nodeInfo.parentItem = 0为杆塔模型的跟
      if (nodeInfo.item === 1 || nodeInfo.parentItem === 0) {
        // 到达根节点 执行点击事件
        this.$nextTick(() => {
          this.locationNode(this.currentNode.item)
        })
      } else {
        const res = await PlayerUtils.call(
          this.player.Native.ModelTree.getItemInfo,
          nodeInfo.parentItem
        )
        // 展开

        this.defaultExpandedKeys.push(res.item)
        await this.expendNode(res)
      }
    },
    clickModelTree(data, node, doLocation) {
      this.currentKey = data.item
      this.locationCode(data.item)
      this.locationNode(data.item)
    },

    async getModelTreeDatas() {
      // 加载模型完成后获取模型数据
      this.modelTreeProp.treeData = await this.player.Native.ModelTree.getRootItems()
      // 删除地球GIS层
      this.modelTreeProp.treeData = _.filter(this.modelTreeProp.treeData, (item) => {
        return (
          item.itemType === this.modelTreeObj.ITEM_PR ||
          item.itemType === this.modelTreeObj.ITEM_NODE
        )
      })
      this.modelTreeProp.modelTreeLoadEnd = true
    },
    async watchMsg(data) {
      if (data.item) {
        this.currentNode = data
        await this.expendNode(data)
      }
    },
    async getTreeCheck() {
      const nodes = this.$refs.modelTreeCableRef.getCheckedNodes()
      const angle = await this.player.Native.Camera.currentParam()
      const codes = nodes.map((o) => {
        return o.code
      })
      console.log(nodes, '--------------')

      return nodes.map((o) => {
        const parent = this.$refs.modelTreeCableRef.getNode(o.parentItem)?.data?.code
        return {
          name: o.name,
          code: o.code,
          parentCode: parent && codes.includes(parent) ? parent : '',
          sceneId: this.sceneId,
          angle: JSON.stringify(angle),
        }
      })
    },
  },
  async mounted() {
    this.player.Native.ModelTree.EventSelectItem.connect(this.watchMsg)
  },
  beforeDestroy() {
    this.player.Native.ModelTree.EventSelectItem.disconnect(this.watchMsg)
  },
}
</script>

<style>
</style>
